(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = this.querySelectorAll('.announcement-item');
      this.index = 0;
      if (this.items.length > 1) {
        this.timer = setInterval(() => this.rotate(), 4000);
      }
    }

    rotate() {
      this.items[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].classList.add('is-active');
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartItems extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-increase], [data-quantity-decrease]');
        if (!button) return;

        const input = button.parentElement.querySelector('.quantity-stepper__input');
        const step = button.hasAttribute('data-quantity-increase') ? 1 : -1;
        const next = Math.max(0, parseInt(input.value || '0', 10) + step);
        input.value = next;
        this.form.submit();
      });
    }
  }

  if (!customElements.get('cart-items')) {
    customElements.define('cart-items', CartItems);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.toggle = this.querySelector('[data-filter-toggle]');
      this.sortSelect = this.querySelector('[data-sort-select]');

      if (this.toggle) {
        this.toggle.addEventListener('click', () => {
          this.form.classList.toggle('is-filters-open');
        });
      }

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => this.form.submit());
      }

      this.querySelectorAll('.filter-group__list input[type="checkbox"]').forEach((input) => {
        input.addEventListener('change', () => this.form.submit());
      });
    }
  }

  if (!customElements.get('collection-filters')) {
    customElements.define('collection-filters', CollectionFilters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
      this.selections = Array.from(this.querySelectorAll('.option-picker')).map((group) => {
        const selected = group.querySelector('.option-value.is-selected');
        return selected ? selected.dataset.optionValue : null;
      });

      this.addEventListener('click', (event) => {
        const button = event.target.closest('.option-value');
        if (!button) return;

        const group = button.closest('.option-picker');
        const index = parseInt(group.querySelector('.option-picker__values').dataset.optionIndex, 10);
        this.selections[index] = button.dataset.optionValue;

        group.querySelectorAll('.option-value').forEach((el) => el.classList.remove('is-selected'));
        button.classList.add('is-selected');
        group.querySelector('[data-selected-value]').textContent = button.dataset.optionValue;

        this.updateVariant();
      });

      this.querySelectorAll('[data-quantity-increase], [data-quantity-decrease]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = this.querySelector('.quantity-stepper__input');
          const step = btn.hasAttribute('data-quantity-increase') ? 1 : -1;
          input.value = Math.max(1, parseInt(input.value || '1', 10) + step);
        });
      });
    }

    updateVariant() {
      const match = this.variants.find((variant) =>
        variant.options.every((value, index) => value === this.selections[index])
      );

      const addToCartBtn = this.querySelector('[data-add-to-cart]');
      const addToCartText = this.querySelector('[data-add-to-cart-text]');
      const priceWrap = document.querySelector('[data-product-price]');
      const idInput = this.querySelector('[data-variant-id]');

      if (!match) {
        addToCartBtn.setAttribute('disabled', 'disabled');
        addToCartText.textContent = window.themeStrings.unavailable;
        return;
      }

      idInput.value = match.id;

      if (priceWrap) {
        const current = priceWrap.querySelector('.product-info__price-current');
        if (current) current.textContent = this.formatMoney(match.price);
      }

      if (match.available) {
        addToCartBtn.removeAttribute('disabled');
        addToCartText.textContent = window.themeStrings.addToCart;
      } else {
        addToCartBtn.setAttribute('disabled', 'disabled');
        addToCartText.textContent = window.themeStrings.soldOut;
      }

      if (match.featured_media) {
        document.querySelectorAll('[data-gallery-slide], [data-gallery-thumb]').forEach((el) => {
          el.classList.toggle('is-active', String(el.dataset.mediaId) === String(match.featured_media.id));
        });
      }
    }

    formatMoney(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.themeStrings.currency });
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb) return;

        const mediaId = thumb.dataset.mediaId;
        this.querySelectorAll('[data-gallery-slide], [data-gallery-thumb]').forEach((el) => {
          el.classList.toggle('is-active', String(el.dataset.mediaId) === String(mediaId));
        });
      });
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('[data-product-recommendations-inner]');
          if (content && content.children.length > 0) {
            this.innerHTML = content.innerHTML;
          }
        })
        .catch(() => {});
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
